"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _index = _interopRequireDefault(require("./index.style"));
const CardMedia = _ref => {
  let {
    title = 'Book Now, Pay Later',
    description = 'With Royal Caribbean Internationals ....',
    mediaMobile = '(max-width: 370px)',
    mediaPortait = '(max-width: 960px)',
    mediaLandscape = '(max-width: 1280px)',
    srcsetMobile,
    srcsetPortrait,
    srcsetLandscape,
    defaultImg,
    children,
    className,
    filterClass,
    buttonLabel = 'Add a flight',
    buttonLink = '',
    buttonAction = () => {}
  } = _ref;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement("picture", {
    className: (0, _clsx.default)(classes.rootMedia, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.alphaFilter, filterClass)
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: mediaMobile,
    srcSet: srcsetMobile
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: mediaPortait,
    srcSet: srcsetPortrait
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: mediaLandscape,
    srcSet: srcsetLandscape
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: defaultImg,
    alt: title
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h1"
  }, title), description && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p"
  }, description), buttonLabel && /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    href: buttonLink,
    className: classes.buttonLabel,
    onClick: buttonAction
  }, buttonLabel), children));
};
var _default = exports.default = CardMedia;